// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4504":"12f57269","7865":"dfb704fc"}[chunkId] + ".chunk.css";
};